const VIDEO_MEETING_DEVICE_KEY = 'videoMeetingDevices';
const clearVideoMeetingDevices = () => localStorage.removeItem(VIDEO_MEETING_DEVICE_KEY);
const defaultValue = {
    videoInputDeviceId: undefined,
    audioInputDeviceId: undefined,
    audioOutputDeviceId: undefined,
};
const setVideoMeetingDevices = (devices) => {
    localStorage.setItem(VIDEO_MEETING_DEVICE_KEY, JSON.stringify(devices));
};
const setVideoInputDeviceId = (videoInputDeviceId) => {
    const currentValue = getVideoMeetingDevices();
    setVideoMeetingDevices({
        ...currentValue,
        videoInputDeviceId,
    });
};
const setAudioInputDeviceId = (audioInputDeviceId) => {
    const currentValue = getVideoMeetingDevices();
    setVideoMeetingDevices({
        ...currentValue,
        audioInputDeviceId,
    });
};
const setAudioOutputDeviceId = (audioOutputDeviceId) => {
    const currentValue = getVideoMeetingDevices();
    setVideoMeetingDevices({
        ...currentValue,
        audioOutputDeviceId,
    });
};
const setDeviceIds = (deviceId, deviceType) => {
    const currentValue = getVideoMeetingDevices();
    setVideoMeetingDevices({
        ...currentValue,
        ...(deviceType === 'Camera' && { videoInputDeviceId: deviceId }),
        ...(deviceType === 'Microphone' && { audioInputDeviceId: deviceId }),
        ...(deviceType === 'Speaker' && { audioOutputDeviceId: deviceId }),
    });
};
const getVideoMeetingDevices = () => {
    const storedDevices = localStorage.getItem(VIDEO_MEETING_DEVICE_KEY);
    return storedDevices ? JSON.parse(storedDevices) : defaultValue;
};
export const DeviceReadinessService = {
    clearVideoMeetingDevices,
    setVideoInputDeviceId,
    setAudioInputDeviceId,
    setAudioOutputDeviceId,
    getVideoMeetingDevices,
    setDeviceIds,
};
//# sourceMappingURL=data:application/json;base64,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